import React, { useContext } from 'react';
import Context from '../../../utils/context';

export default function ActionIcons({ style }) {
  const context = useContext(Context);
  const user = context.auth.getCurrentUser();
  if (user.current_profile_type === 'Patient') {
    return <span></span>;
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', ...style }}>
      <a href='/report-an-event' target='_blank' rel='noopener noreferrer'>
        <svg width='24' height='24' viewBox='0 0 20 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M1.59487 14.5062L8.5419 1.91295C9.15206 0.806197 10.7583 0.806197 11.3676 1.91295L18.3138 14.5062C18.8966 15.5664 18.1212 16.8601 16.8992 16.8601H3.00773C1.78656 16.8601 1.01039 15.5664 1.59573 14.5062H1.59487Z'
            fill='#F5C518'
            stroke='#CC9900'
            strokeWidth='1'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path d='M9.95383 6.60504V10.5493' stroke='#1A1A1A' strokeWidth='1.5' strokeLinecap='round' />
          <path d='M9.95383 13.3102V13.7047' stroke='#1A1A1A' strokeWidth='1.5' strokeLinecap='round' />
        </svg>
      </a>
    </div>
  );
}
